import React from 'react';
import Api from '../util/Api';

class VoucherSuccess extends React.Component {
    constructor() {
        super();
        this.state = {
            copied: false,
            title: '',
            email: '',
            downloadLink: ''
        };

        this.formBlockRef = React.createRef();
    }

    componentDidMount() {
        if (this.state.downloadLink.length == 0) {
            Api.getPurchasedVoucher(this.props.sessionId, (success, data) => {
                if (success) {
                    this.setState({
                        title: data.title,
                        email: data.email,
                        downloadLink: data.downloadUrl,
                    });

                    // fix card
                    // GtmHelper.payGiftVoucher(this.props.item, 'unknown');
                    if (typeof GtmHelper !== 'undefined') {
                        GtmHelper.confirmGiftVoucher(this.props.item, this.props.sessionId);
                    }
                    window.scrollTo(0, this.successBlockRef.current.offsetTop - 150);
                }
            });
        }
    }

    getSubtitle() {
        const subtitle = trans.gift_voucher_order_success_subtitle
            .replace('{{voucher_title}}', this.state.title);

        return (
            <span>{subtitle} <b>"{this.state.email}".</b></span>
        )
    }

    copyToClipboard() {
        navigator.clipboard.writeText(this.state.downloadLink);
        this.setState({ copied: true })
    }

    render() {
        return (
            <div className="container voucher-form voucher-success" ref={this.successBlockRef}>
                <i className="voucher-success__icon fas fa-check-circle"></i>
                <h1 className="voucher-success__title w-full text-center">
                    {trans.gift_voucher_order_success_title}
                </h1>
                <div className="voucher-success__subtitle w-full text-center">
                    {this.getSubtitle()} <br/>
                    {trans.gift_voucher_order_success_link}
                </div>
                <div className="voucher-success__link mx-auto flex items-center">
                    <a target="_blank" href={this.state.downloadLink} className="voucher-success__url" id="voucher-download-url">{this.state.downloadLink}</a>
                    <span className="voucher-success__copy" onClick={()=>this.copyToClipboard()}>
                        { this.state.copied ? <i className="fas fa-check"></i> : trans.copy_link }
                    </span>
                </div>
                <button className="btn btn-back" onClick={this.props.onBackClick}>
                    <span className="btn-text">{trans.continue_browsing}</span>
                </button>
            </div>
        )
    }
}

export default VoucherSuccess;


// WEBPACK FOOTER //
// ./scripts/components/VoucherSuccess.jsx